module.exports = __webpack_public_path__ + "img/temp_image.e66ad13e.png";